
import axios from "axios";
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      id: null,
      pedido: null,
      clienteId: null,
      tipoSituacao: '',
      nfeRelacionada: '',
      filtroFormaPagto: '',
      filtroBoleto: '',
      filtroNf: '',
      filtroFinanceiro: '',
      filtroOrigem: '',
      filtroAlterado: '',
      filtroEntrega: '',
      filtrosTabelaListagem: null,
      filtroAvancado: false,
      parametrosExpedicao: {
        OP_EXPEDICAO_DIRETA: '0'
      },
      parametrosExpedicaoCarregados: false,
      registroSelecionadoId: null,
      paginaAtual: 1,
      perPage: 50,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    PER_PAGE: state => { 
        return state.perPage
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    PEDIDO: state => {
        return state.pedido
    },
    TIPO_SITUACAO: state => {
        return state.tipoSituacao
    },
    NFE_RELACIONADA: state => {
        return state.nfeRelacionada
    },
    FILTRO_FORMA_PAGTO: state => {
        return state.filtroFormaPagto
    },
    FILTRO_BOLETO: state => {
        return state.filtroBoleto
    },
    FILTRO_NF: state => {
        return state.filtroNf
    },
    FILTRO_FINANCEIRO: state => {
        return state.filtroFinanceiro
    },
    FILTRO_ORIGEM: state => {
        return state.filtroOrigem
    },
    FILTRO_ALTERADO: state => {
        return state.filtroAlterado
    },
    FILTRO_ENTREGA: state => {
        return state.filtroEntrega
    },
    FILTROS_TABELA_LISTAGEM: state => {
        return state.filtrosTabelaListagem
    },
    FILTRO_AVANCADO: state => {
        return state.filtroAvancado
    },
    PARAMETROS_EXPEDICAO: state => {
        return state.parametrosExpedicao
    },
    PARAMETROS_EXPEDICAO_CARREGADOS: state => {
        return state.parametrosExpedicaoCarregados
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_PER_PAGE: (state, payload) => {
          state.perPage = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CLIENTE_ID: (state, payload) => {
          state.clienteId = payload
      },
      SET_PEDIDO: (state, payload) => {
          state.pedido = payload
      },
      SET_TIPO_SITUACAO: (state, payload) => {
          state.tipoSituacao = payload
      },
      SET_NFE_RELACIONADA: (state, payload) => {
          state.nfeRelacionada = payload
      },
      SET_FILTRO_FORMA_PAGTO: (state, payload) => {
          state.filtroFormaPagto = payload
      },
      SET_FILTRO_BOLETO: (state, payload) => {
          state.filtroBoleto = payload
      },
      SET_FILTRO_NF: (state, payload) => {
          state.filtroNf = payload
      },
      SET_FILTRO_FINANCEIRO: (state, payload) => {
          state.filtroFinanceiro = payload
      },
      SET_FILTRO_ORIGEM: (state, payload) => {
          state.filtroOrigem = payload
      },
      SET_FILTRO_ALTERADO: (state, payload) => {
          state.filtroAlterado = payload
      },
      SET_FILTRO_ENTREGA: (state, payload) => {
          state.filtroEntrega = payload
      },
      SET_FILTROS_TABELA_LISTAGEM: (state, payload) => {
          if (!payload) {
            state.filtrosTabelaListagem = null
            return
          }
          const clone = {}
          Object.keys(payload).forEach(key => {
            clone[key] = Array.isArray(payload[key]) ? [...payload[key]] : []
          })
          state.filtrosTabelaListagem = clone
      },
      SET_FILTRO_AVANCADO: (state, payload) => {
          state.filtroAvancado = !!payload
      },
      SET_PARAMETROS_EXPEDICAO: (state, payload) => {
          state.parametrosExpedicao = {
            ...state.parametrosExpedicao,
            ...payload,
            OP_EXPEDICAO_DIRETA: String((payload && payload.OP_EXPEDICAO_DIRETA) || '0').trim()
          }
          state.parametrosExpedicaoCarregados = true
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.id = null
        state.pedido = null
        state.clienteId = null
        state.tipoSituacao = ''
        state.nfeRelacionada = ''
        state.filtroFormaPagto = ''
        state.filtroBoleto = ''
        state.filtroNf = ''
        state.filtroFinanceiro = ''
        state.filtroOrigem = ''
        state.filtroAlterado = ''
        state.filtroEntrega = ''
        state.filtrosTabelaListagem = null
        state.filtroAvancado = false
        state.registroSelecionadoId = null
        state.paginaAtual = 1
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}, { skipConfirmation = false } = {}) => {
      return new Promise((resolve, reject) => {
        let id = (getters.ID !== null ? getters.ID : '')
        let clienteId = (getters.CLIENTE_ID !== null ? getters.CLIENTE_ID : '')
        let pedido = (getters.PEDIDO !== null ? getters.PEDIDO : '')
        let tipoSituacao = (getters.TIPO_SITUACAO !== null ? getters.TIPO_SITUACAO : '')
        let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
        let dt2 = (getters.DT2 !== null ? getters.DT2 : '')
        let nfeRelacionada = getters.NFE_RELACIONADA || ''
        let filtroFormaPagto = getters.FILTRO_FORMA_PAGTO || ''
        let filtroBoleto = getters.FILTRO_BOLETO || ''
        let filtroNf = getters.FILTRO_NF || ''
        let filtroFinanceiro = getters.FILTRO_FINANCEIRO || ''
        let filtroOrigem = getters.FILTRO_ORIGEM || ''
        let filtroAlterado = getters.FILTRO_ALTERADO || ''
        let filtroEntrega = getters.FILTRO_ENTREGA || ''

        let uri = `/api/protected/venda/pesquisar?id=${id}&dt1=${dt1}`+
                  `&dt2=${dt2}&pedido=${pedido}`
        if (tipoSituacao) {
          uri += `&situacao=${tipoSituacao}`
        } 
        if (clienteId) {
          uri += `&clienteId=${clienteId}`
        }
        if (nfeRelacionada) {
          uri += `&nfeRelacionada=${encodeURIComponent(nfeRelacionada)}`
        }
        if (filtroFormaPagto) {
          uri += `&filtroFormaPagto=${encodeURIComponent(filtroFormaPagto)}`
        }
        if (filtroBoleto) {
          uri += `&filtroBoleto=${encodeURIComponent(filtroBoleto)}`
        }
        if (filtroNf) {
          uri += `&filtroNf=${encodeURIComponent(filtroNf)}`
        }
        if (filtroFinanceiro) {
          uri += `&filtroFinanceiro=${encodeURIComponent(filtroFinanceiro)}`
        }
        if (filtroOrigem) {
          uri += `&filtroOrigem=${encodeURIComponent(filtroOrigem)}`
        }
        if (filtroAlterado) {
          uri += `&filtroAlterado=${encodeURIComponent(filtroAlterado)}`
        }
        if (filtroEntrega) {
          uri += `&filtroEntrega=${encodeURIComponent(filtroEntrega)}`
        }
        
        axios
          .get(uri)
          .then(({ data, status }) => {
            // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
            if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
              // Retorna os dados sem comitar, indicando que precisa de confirmação
              resolve({ 
                data, 
                status,
                needsConfirmation: true,
                count: data.length
              })
              return
            }
            
            // Carrega os dados normalmente
            commit("SET_LISTA", data)
            
            if (status === 200 || status === 201) {
              resolve({ data, status, needsConfirmation: false })
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    CARREGAR_PARAMETROS_EXPEDICAO: ({ commit, getters }, { force = false } = {}) => {
      return new Promise((resolve, reject) => {
        if (!force && getters.PARAMETROS_EXPEDICAO_CARREGADOS) {
          return resolve(getters.PARAMETROS_EXPEDICAO)
        }

        axios
          .get('/api/protected/parametro/getDados')
          .then(({ data }) => {
            const parametros = Array.isArray(data) && data.length ? data[0] : {}
            const payload = {
              OP_EXPEDICAO_DIRETA: String(parametros.OP_EXPEDICAO_DIRETA || '0').trim()
            }
            commit('SET_PARAMETROS_EXPEDICAO', payload)
            resolve(payload)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/venda-store.js